import { Component } from '@angular/core';
import { UndeliveredReasonsEditComponent } from '../../../../components/admin-dashboard-component/undelivered-reasons-component/undelivered-reasons-edit-component/undelivered-reasons-edit-component';

@Component({
  selector: 'app-undelivered-reasons-edit-page',
  standalone: true,
  imports: [UndeliveredReasonsEditComponent],
  templateUrl: './undelivered-reasons-edit.html',
  styleUrl: './undelivered-reasons-edit.scss',
})
export class UndeliveredReasonsEdit {}